<div class="wrapper animated fadeIn">

    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="./assets/global/images/cabeceras/bg_admin_usuarios.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración Comercial</h1>
        </div>
    </div>
    <dx-load-panel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoader" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false" [message]="messageLoader" height="10%" width="15%"></dx-load-panel>
    <div class="container-fluid">
        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a [routerLink]='["/user-comercial"]'>Usuarios comerciales</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración Usuarios</h4>
                </div>
            </div>
        </div>
        <br />
        <div class="row animated fadeIn" *ngIf="add || edit">
            <div class="col-md-12">
                <div class="card-box">
                    <form [formGroup]="userForm" autocomplete="off">
                        <div class="form_title">
                            <h4><strong> <i class=" icon-user-follow"></i></strong>Información Personal</h4>
                            <p>Ingrese sus datos personales </p>
                        </div>
                        <div class="step">
                            <div class="row">
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>{{"usuarios.crearUsuario.Nombre" | translate}}<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control required" id="nombres" formControlName="Nombre" placeholder="Escribe tus nombres">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>{{"usuarios.crearUsuario.PrimerApellido" | translate}}<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control required" id="Primer-apellido" formControlName="Apellido1" placeholder="Escribe tu primer apellido">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>{{"usuarios.crearUsuario.SegundoApellido" | translate}}</label>
                                        <input type="text" class="form-control" id="Segundo-apellido" formControlName="Apellido2" placeholder="Escribe tu segundo apellido">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>{{"usuarios.crearUsuario.TipoDocumento" | translate}}<span class="text-danger">*</span></label>
                                        <select class="form-control required" formControlName="IdTipoDocumento" id="Tipo-identificacion" placeholder="Selecciona el tipo de identificación">
                    <option value="">Selecciona el tipo de identificación</option>
                    <option *ngFor="let opc of listTypeDocument" [value]="opc.idAdmCategoria">{{opc.nombre}}</option>
                  </select>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>{{"usuarios.crearUsuario.NumeroDocumento" | translate}}<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control required" id="numero-identificacion" formControlName="NumeroDocumento" placeholder="Escribe tu número de identificación">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>{{"usuarios.crearUsuario.CorreoElectronico" | translate}}<span
                      class="text-danger">*</span></label>
                                        <input type="text" class="form-control required" id="correo" formControlName="CorreoElectronico" placeholder="Escribe tu correo electrónico como nombre de usuario">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>{{"usuarios.crearUsuario.ConfirmarCorreo" | translate}}<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" id="confirmar-correo" formControlName="ConfirmarCorreoElectronico" placeholder="Confirma tu correo electrónico">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>Cargo<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control required" id="cargo" formControlName="Cargo" placeholder="Escribe tu cargo">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label>{{"usuarios.crearUsuario.Telefono" | translate}}<span class="text-danger">*</span></label>
                                        <input type="text" class="form-control required" id="telefono-opcionL" formControlName="Telefono" placeholder="Escribe tu número de contacto">
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <label for="ciudad">Ciudad</label>
                                    <ng-select2 id="ciudad" class="form-control" formControlName="Ciudad" [data]="listCitys" [width]="500" [options]="singleOptions">
                                    </ng-select2>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <label for="tipoPersonaFake">Tipo de persona</label>
                                    <select id="tipoPersonaFake" class="form-control" (change)="onChangeTipoPersona($event)">
                                        <option *ngFor="let item of listTipoPersonaFake" value="{{item.id}}">{{item.name}}</option>
                                    </select>
                                </div>
                                <div class="col-md-6 col-sm-6">
                                    <label for="tipoPersona">Tipo de cargo</label>
                                    <select *ngIf="listTipoPersona.length > 0" id="tipoPersona" class="form-control" formControlName="IdSegTipoPersona">
                                        <option *ngFor="let item of listTipoPersona" value="{{item.idSegTipoPersona}}">{{item.nombre}}</option>
                                    </select>
                                    <input *ngIf="listTipoPersona.length == 0" type="text" name="cargando" id="cargando" value="Cargando..." disabled="true" class="form-control">
                                </div>
                            </div>
                        </div>
                        <!--End step -->
                        <div class="step">
                            <div class="form_title">
                                <h4><strong><i class="icon-login"></i></strong>Datos Acceso</h4>
                                <p>Escoja la Empresa para acceder a la aplicación</p>
                            </div>
                            <!-- end row -->
                        </div>
                        <!--End step -->
                    </form>
                    <app-table-empresa></app-table-empresa>
                    <div class="form-group text-right m-b-0">
                        <button type="reset" (click)="cancel()" class="btn btn-light waves-effect m-l-5"> {{ "botones.Cancelar" |
            translate }}</button>
                        <button class="btn btn-custom waves-effect waves-light" type="submit" (click)="onSubmit()" [disabled]="!userForm.valid">{{
            "botones.Guardar" | translate }}</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- USERLIST -->
        <br />
        <div class="row animated fadeIn" [hidden]="add || edit">
            <div class="col-4">
                <button (click)="add = true" class="btn btn-primary mr-2">{{"botones.AgregarUsuario" | translate}}</button>
            </div>
            <div class="col-12">
                <div class="card-box table-responsive">
                    <table datatable [dtOptions]="dtOptions" class="table table-hover m-0 nowrap" cellspacing="0" width="100%">
                        <thead>
                            <tr>
                                <th>Acciones</th>
                                <th>{{ "usuarios.tablaUsuario.Nombre" | translate }}</th>
                                <th>{{ "usuarios.tablaUsuario.NumeroDocumento" | translate }}</th>
                                <th>{{ "usuarios.tablaUsuario.CorreoElectronico" | translate }}</th>
                                <th>{{ "usuarios.tablaUsuario.FechaUltimoIngreso" | translate }}</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="listUsers?.length != 0">
                            <tr *ngFor="let user of listUsers; let i = index">
                                <td>
                                    <div class="btn-group dropdown">
                                        <button class="table-action-btn dropdown-toggle arrow-none btn btn-light btn-sm" data-toggle="dropdown" data-bs-toggle="dropdown" aria-expanded="false"><i class="mdi mdi-dots-horizontal"></i></button>
                                        <!-- <a href="#" class="table-action-btn dropdown-toggle arrow-none btn btn-light btn-sm" data-toggle="dropdown" aria-expanded="false"><i class="mdi mdi-dots-horizontal"></i></a> -->
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a class="dropdown-item btn btn-sm btn-purple" (click)="loadUser(user.idSegUsuario)"><i class="mdi mdi-file-document-box mr-2 vertical-middle"></i>Editar</a>
                                        </div>
                                    </div>
                                </td>
                                <td class="font-w600">{{user.nombre}}</td>
                                <td><span class="label label-danger">{{user.numeroDocumento}}</span> </td>
                                <td><span class="label label-danger">{{user.correoElectronico}}</span></td>
                                <td class="hidden-xs"> <em class="text-muted">{{user.fechaCreacion | date:"short"}}</em></td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="listUsers?.length == 0">
                            <tr>
                                <td colspan="3" class="no-data-available">No data!</td>
                            </tr>
                            <tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="blanco"></div>